"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _ProgressBar = _interopRequireDefault(require("./ProgressBar"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var StrengthIndicator = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(StrengthIndicator, _Component);

  var _super = _createSuper(StrengthIndicator);

  function StrengthIndicator() {
    var _this;

    (0, _classCallCheck2["default"])(this, StrengthIndicator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(StrengthIndicator, [{
    key: "render",
    value: function render() {
      var surfaceLight = this.context.theming.theme.surfaceLight;
      var _this$props = this.props,
          className = _this$props.className,
          strength = _this$props.strength,
          height = _this$props.height,
          _this$props$backgroun = _this$props.backgroundColor,
          backgroundColor = _this$props$backgroun === void 0 ? surfaceLight : _this$props$backgroun;
      var color = this.color;

      if (color == null) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_ProgressBar["default"], {
        className: (0, _styling.css)(className),
        color: color,
        progress: strength,
        backgroundColor: backgroundColor,
        height: height
      });
    }
  }, {
    key: "color",
    get: function get() {
      var _this$props2 = this.props,
          _this$props2$warningR = (0, _slicedToArray2["default"])(_this$props2.warningRange, 2),
          warningStart = _this$props2$warningR[0],
          warningEnd = _this$props2$warningR[1],
          strength = _this$props2.strength;

      var _this$context$theming = this.context.theming.theme,
          negativeDark = _this$context$theming.negativeDark,
          warningLight = _this$context$theming.warningLight,
          positive = _this$context$theming.positive;

      if (strength < warningStart) {
        return negativeDark;
      }

      if (strength >= warningStart && strength < warningEnd) {
        return warningLight;
      }

      if (strength >= warningEnd) {
        return positive;
      }

      return null;
    }
  }]);
  return StrengthIndicator;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  strength: {
    required: true,
    type: "number",
    description: "Current strength. Value should be between 0 and 1"
  },
  warningRange: {
    required: true,
    type: "[number, number]",
    description: "Range in which the strength is in warning: " + "not bad (red), but not strong (green) either"
  }
}, _class3.demoProps = {
  strength: 0.6,
  warningRange: [0.3, 0.7]
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "color", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "color"), _class2.prototype)), _class2)) || _class;

var _default = StrengthIndicator;
exports["default"] = _default;